import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import HomePage from "./components/HomePage";
import GrandiAziendePage from "./components/GrandiAziendePage";
import PubblicaPage from "./components/PubblicaPage";
import PreventivoPage from "./components/PreventivoPage";
import TrovaAgentePage from "./components/TrovaAgentePage";
import ServiceDetailPage from "./components/ServiceDetailPage";
import DispositiviPage from "./components/DispositiviPage";
import ConnettivitaPage from "./components/ConnettivitaPage";
import FissoMobilePage from "./components/FissoMobilePage";
import ICTPage from "./components/ICTPage";
import Machine2MachinePage from "./components/Machine2MachinePage";
import CarrierePage from "./components/CarrierePage";
import LoginCRM from "./components/LoginCRM";
import LoginCliente from "./components/LoginCliente";
import DashboardAdmin from "./components/DashboardAdmin";
import SalesDashboard from "./components/SalesDashboard";
import ClientDashboard from "./components/ClientDashboard";
import LeadDetailPage from "./components/LeadDetailPage";
import LeadsPipelinePage from "./components/LeadsPipelinePage";
import CreateLeadPage from "./components/CreateLeadPage";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/piccole-medie-imprese" element={<FissoMobilePage />} />
            <Route path="/grandi-aziende" element={<GrandiAziendePage />} />
            <Route path="/pubblica-amministrazione" element={<PubblicaPage />} />
            <Route path="/preventivo" element={<PreventivoPage />} />
            <Route path="/trova-agente" element={<TrovaAgentePage />} />
            <Route path="/servizio/:slug" element={<ServiceDetailPage />} />
            <Route path="/dispositivi" element={<DispositiviPage />} />
            <Route path="/connettivita" element={<ConnettivitaPage />} />
            <Route path="/office" element={<FissoMobilePage />} />
            <Route path="/ict" element={<ICTPage />} />
            <Route path="/machine2machine" element={<Machine2MachinePage />} />
            <Route path="/carriere" element={<CarrierePage />} />

            {/* Authentication Routes */}
            <Route path="/login-crm" element={<LoginCRM />} />
            <Route path="/login-cliente" element={<LoginCliente />} />

            {/* Protected Dashboard Routes */}
            <Route path="/dashboard-admin" element={<DashboardAdmin />} />
            <Route path="/dashboard-sales" element={<SalesDashboard />} />
            <Route path="/dashboard-cliente" element={<ClientDashboard />} />

            {/* Lead Management Routes */}
            <Route path="/lead/nuovo" element={<CreateLeadPage />} />
            <Route path="/lead/:leadId" element={<LeadDetailPage />} />
            <Route path="/leads/pipeline" element={<LeadsPipelinePage />} />
          </Routes>
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
